import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FilterMetadata, FilterService, LazyLoadEvent, MessageService, SelectItem } from 'primeng/api';
import { ImportOrderGateway } from 'src/app/application/gateway/ImportOrderGateway';
import { AdminOrderFilter, AdminOrderRequest, GenericOrderDetail, ImportOrderInformation } from 'src/app/domain/models/ImportOrder';
import { Routes } from 'src/app/infrastructure/routes';
import { OrderUtils } from 'src/app/ui/util/order-utils';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Calendar } from 'primeng/calendar';
import { SpeciesUtils } from 'src/app/ui/util/species-utils';
import { BasicUser } from 'src/app/domain/models/User';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { Table } from 'primeng/table';

Calendar.prototype.getDateFormat = () => 'dd-mm-yy';

@Component({
  selector: 'app-admin-manage-orders-page',
  templateUrl: './admin-manage-orders-page.component.html',
  styleUrls: ['./admin-manage-orders-page.component.css'],

})
export class AdminManageOrdersPageComponent implements OnInit {

  loading: boolean = false
  paidRegistered: boolean = true

  orders: ImportOrderInformation[] = []
  filteredOrders: ImportOrderInformation[] = []
  isCloseSale: boolean = false
  globalFilters: string[] = []

  totalCount = 0;
  pageSize = 100;

  @Input()
  isProgram: boolean = false

  request!: AdminOrderRequest

  orderTypeOptions: any[] = [
    {
      label: 'Programa',
      value: true
    },
    {
      label: 'Marketplace',
      value: false
    }
  ]

  filterForm: FormGroup = this._formBuilder.group({
    orderId: [''],
    programId: [''],
    specie: [''],
    variety: [''],
    status: ['']
  })

  ordersArray: number[] = []
  programsArray: number[] = []
  importersArray: string[] = []
  exportersArray: string[] = []
  containersArray: string[] = []
  instructivesArray: string[] = []
  shipsArray: string[] = []
  speciesArray: string[] = []
  varietiesArray: string[] = []

  ordersFilter: SelectItem[] = []
  programsFilter: SelectItem[] = []
  importersFilter: SelectItem[] = []
  exportersFilter: SelectItem[] = []
  containersFilter: SelectItem[] = []
  instructivesFilter: SelectItem[] = []
  shipsFilter: SelectItem[] = []
  speciesFilter: SelectItem[] = []
  varietiesFilter: SelectItem[] = []
  statusFilter: SelectItem[] = []
  searchTerm: string = '';
  selectedStatus: SelectItem = {} as SelectItem

  filterDate: Date | undefined;

  user: BasicUser | undefined

  constructor(private _router: Router,
    private _messageService: MessageService,
    private _importOrderService: ImportOrderGateway,
    private readonly _formBuilder: FormBuilder,
    private readonly translate: TranslateService,
    private readonly filterService: FilterService,
    private readonly _authService: AuthGateway
  ) {
  }

  @ViewChild('dt') dt!: Table;

  customFilter(value: string) {
    // TODO aleyton: validar o eliminar
    if (this.dt.filteredValue !== null && value) {
      this.clearSelectFilters()
      this.dt.filteredValue.forEach(x => {
        const fullOrder = this.getFullOrder(x)
        this.setFilters(fullOrder)
      })
    }
  }

  clearFilters() {
    this.dt.clear()
  }

  filterTable(value: string) {
      this.dt.filterGlobal(value, 'contains');
  }

  filterGlobalImportRequestEvent(event: any) {
    this.filterTable(event.target.value);
  }

  ngOnInit(): void {
    this.user = this._authService.getUser()
    this.request ={
    containers: [],
    exporters: [],
    importers: [],
    isProgram: this.isProgram,
    ships: [],
    varieties: [],
    weeks: [],
    species: [],
    programs: [],
    sequences: [],
    dates: [],
    instructions: [],
    searchTerm: "",
    status: "ImporterOrderConfirmed,ImporterPaymentConfirmed",
  }
    this.globalFilters = ['importOrder.sequence', 'importOrder.importer.companyName',
      'importOrder.directSaleProgramId' , 'genericDetails[0]?.exporterCompanyName',
      'containerNumber', 'instructive', 'ship'];

    this.setStatusFilter()
    this.getAdminOrderFilters()

    this.filterService.register('filter-date', (value: any, filter: any): boolean => {
      if (!filter) return true
      const found = moment(value).format("DD-MM-YYYY") === moment(filter).format("DD-MM-YYYY")
      return found;
    });
  }

  setStatusFilter() {
    this.translate.get([
      'AdminOrderManagement.Status.ConfirmedPurchase',
      'AdminOrderManagement.Status.Created',
      'AdminOrderManagement.Status.PendingPallets',
      'AdminOrderManagement.Status.PendingQCPayment',
      'AdminOrderManagement.Status.Canceled',
      'AdminOrderManagement.Status.Expired',
    ]).subscribe({
      next: (translations) => {
        this.statusFilter = [
          {value: 'ImporterOrderConfirmed,ImporterPaymentConfirmed',
            label: translations['AdminOrderManagement.Status.ConfirmedPurchase'], styleClass: 'confirmed-purchase-order'},
          {value: 'Created',
            label: translations['AdminOrderManagement.Status.Created'], styleClass: 'created-order'},
          {value: 'PendingVerifyPallets',
            label: translations['AdminOrderManagement.Status.PendingPallets'], styleClass: 'pending-pallets-order'},
          // {value: 'PendingQCPayment',
          //   label: translations['AdminOrderManagement.Status.PendingQCPayment'], styleClass: 'pending-qc-order'},
          {value: 'Cancelled',
            label: translations['AdminOrderManagement.Status.Canceled'], styleClass: 'canceled-order'},
          {value: 'Expired',
            label: translations['AdminOrderManagement.Status.Expired'], styleClass: 'expired-order'}
        ]
        this.filterForm.get('status')?.setValue(this.statusFilter[0].value)
        this.selectedStatus = this.statusFilter[0]
        // this.getAllByStatus(this.statusFilter[0].value)
      },
      error: (_) => {}
    })
  }

  getAllByStatus(status: string) {
    this.orders = []
    this.filteredOrders = []
    this.loading = true
    this._importOrderService.getAllByStatus(status, this.isProgram).subscribe({
      next: (v) => {
        this.clearSelectFilters()
        const result: ImportOrderInformation[] = []

        v.forEach(x => {
          const fullOrder = this.getFullOrder(x)
          result.push(fullOrder)
          this.setFilters(fullOrder)
        })

        this.sortFiters()
        this.orders = result
        this.filteredOrders = result
        this.onFilter()
        this.loading = false
      },
      error: (e) => {
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar las órdenes.' });
      },
      complete: () =>  {
        this.loading = false
      }
    })
  }

  getAllByPendingQcPaymentApproved() {
    this.orders = []
    this.filteredOrders = []
    this.loading = true
    this._importOrderService.getAllByPendingApprovedAdmin(this.isProgram).subscribe({
      next: (v) => {
        this.clearSelectFilters()
        const result: ImportOrderInformation[] = []

        v.forEach(x => {
          const fullOrder = this.getFullOrder(x)
          result.push(fullOrder)
          this.setFilters(fullOrder)
        })

        this.sortFiters()
        this.orders = result;
        this.filteredOrders = result;
        this.onFilter()
        this.loading = false
      },
      error: (e) => {
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar las órdenes.' });
      },
      complete: () =>  {
        this.loading = false
      }
    })
  }

  getSpeciesName(data: GenericOrderDetail): string {
    if (this.user) {
      const dataSpecie = {...data, name: data.speciesNameEn, nameEs: data.speciesNameEs}
      return SpeciesUtils.getSpeciesName(this.user.lang, dataSpecie)
    }
    return ''
  }

  getFullOrder(x: ImportOrderInformation) {
    const species = x.genericDetails.flatMap((el) => this.getSpeciesName(el))
    const varieties = x.genericDetails.flatMap((el) => el.varietyName)
    return {
      ...x, containerNumber: x.delivery?.containerNumber ?? this.getPendingText(),
      ship: x.delivery?.ship ?? this.getPendingText(),
      instructive: x.delivery?.deliveryInstructions ?? this.getPendingText(),
      exporterName: x.genericDetails[0]?.exporterCompanyName,
      speciesName: species.join(", "),
      varietiesName: varieties.join(", ")
    }
  }

  clearSelectFilters() {
    this.ordersArray = []
    this.programsArray = []
    this.importersArray = []
    this.exportersArray = []
    this.containersArray = []
    this.instructivesArray = []
    this.shipsArray = []
    this.speciesArray = []
    this.varietiesArray = []

    this.ordersFilter = []
    this.programsFilter = []
    this.importersFilter = []
    this.exportersFilter = []
    this.containersFilter = []
    this.instructivesFilter = []
    this.shipsFilter = []
    this.speciesFilter = []
    this.varietiesFilter = []
  }

  setFilters(row: ImportOrderInformation) {
    if (row.importOrder.sequence !== undefined && !this.ordersArray.includes(row.importOrder.sequence)) {
      this.ordersArray.push(row.importOrder.sequence)
      this.ordersFilter.push({value: row.importOrder.sequence, label: row.importOrder.sequence.toString()})
    }
    if (row.importOrder.directSaleProgramId && !this.programsArray.includes(row.importOrder.directSaleProgramId)) {
      this.programsArray.push(row.importOrder.directSaleProgramId)
      this.programsFilter.push({value: row.importOrder.directSaleProgramId, label: row.importOrder.directSaleProgramId.toString()})
    }
    if (row.importOrder.importer.companyName && !this.importersArray.includes(row.importOrder.importer.companyName)) {
      this.importersArray.push(row.importOrder.importer.companyName)
      this.importersFilter.push({value: row.importOrder.importer.companyName, label: row.importOrder.importer.companyName})
    }
    if (row.exporterName && !this.exportersArray.includes(row.exporterName)) {
      this.exportersArray.push(row.exporterName)
      this.exportersFilter.push({value: row.exporterName, label: row.exporterName})
    }
    if (row.containerNumber && !this.containersArray.includes(row.containerNumber)) {
      this.containersArray.push(row.containerNumber)
      this.containersFilter.push({value: row.containerNumber, label: row.containerNumber})
    }
    if (row.instructive && !this.instructivesArray.includes(row.instructive)) {
      this.instructivesArray.push(row.instructive)
      this.instructivesFilter.push({value: row.instructive, label: row.instructive})
    }
    if (row.ship && !this.shipsArray.includes(row.ship)) {
      this.shipsArray.push(row.ship)
      this.shipsFilter.push({value: row.ship, label: row.ship})
    }

    row.genericDetails.forEach((el) => {
      const specieName = this.getSpeciesName(el);
      if (specieName && !this.speciesArray.includes(specieName)) {
        this.speciesArray.push(specieName)
        this.speciesFilter.push({value: specieName, label: specieName})
      }
      if (el.varietyName && !this.varietiesArray.includes(el.varietyName)) {
        this.varietiesArray.push(el.varietyName)
        this.varietiesFilter.push({value: el.varietyName, label: el.varietyName})
      }
    });
  }

  sortFiters() {
    this.ordersFilter.sort((a, b) => a.value - b.value)
    this.programsFilter.sort((a, b) => a.value - b.value)
    this.importersFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.exportersFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.containersFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.instructivesFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.shipsFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.speciesFilter.sort((a, b) => a.value.localeCompare(b.value))
    this.varietiesFilter.sort((a, b) => a.value.localeCompare(b.value))
  }

  getPendingText() {
    return this.translate.instant('AdminOrderManagement.PendingText')
  }

  onFilter() {
    if (!this.ordersFilter.some((el) => this.filterForm.get('orderId')?.value === el.value)) {
      this.filterForm.get('orderId')?.setValue('')
    }
    if (!this.programsFilter.some((el) => this.filterForm.get('programId')?.value === el.value)) {
      this.filterForm.get('programId')?.setValue('')
    }
    if (!this.speciesFilter.some((el) => this.filterForm.get('specie')?.value === el.value)) {
      this.filterForm.get('specie')?.setValue('')
    }
    if (!this.varietiesFilter.some((el) => this.filterForm.get('variety')?.value === el.value)) {
      this.filterForm.get('variety')?.setValue('')
    }

    this.filteredOrders = this.orders.filter(item => this.applyFilters(item));
    this.clearSelectFilters()
    this.filteredOrders.forEach(x => {
      const fullOrder = this.getFullOrder(x)
      this.setFilters(fullOrder)
    })
    this.sortFiters()
  }

  onFilterStatus() {
    if (this.filterForm.get('status')?.value) {
      const dataStatus = this.statusFilter.find((el) => el.value === this.filterForm.get('status')?.value)
      if (dataStatus !== undefined) this.selectedStatus = dataStatus

      this.changeFilter()

      // if (this.filterForm.get('status')?.value === 'PendingQCPayment') {
      //   this.getAllByPendingQcPaymentApproved()
      // }
      // else {
      //   // this.getAllByStatus(this.filterForm.get('status')?.value ?? '')
      // }

      if (this.dt) {
        this.dt.first = 0;
      }
    }
  }

  applyFilters(item: ImportOrderInformation): boolean {
    if (typeof this.filterForm.get('orderId')?.value === 'number') {
      if (this.filterForm.get('orderId')?.value !== item.importOrder.sequence) {
        return false;
      }
    }

    if (typeof this.filterForm.get('programId')?.value === 'number') {
      if (this.filterForm.get('programId')?.value !== item.importOrder.directSaleProgramId) {
        return false;
      }
    }

    if (this.filterForm.get('specie')?.value) {
      let found = item.genericDetails.some((el) => this.filterForm.get('specie')?.value === el.speciesNameEs)
      if (!found) return false
    }

    if (this.filterForm.get('variety')?.value) {
      let found = item.genericDetails.some((el) => this.filterForm.get('variety')?.value === el.varietyName)
      if (!found) return false
    }

    /* if (this.searchTerm.trim()) {
      const isOrder = item.importOrder.sequence?.toString() ? item.importOrder.sequence.toString().toLocaleLowerCase().includes(this.searchTerm.toLowerCase()): false;
      const isImporter = item.importOrder?.importer?.companyName ? item.importOrder?.importer?.companyName.toString().toLocaleLowerCase().includes(this.searchTerm.toLowerCase()): false;
      const isExporter = item.genericDetails[0]?.exporterCompanyName ? item.genericDetails[0]?.exporterCompanyName.toString().toLocaleLowerCase().includes(this.searchTerm.toLowerCase()): false;
      const isContainer = item.containerNumber ? item.containerNumber.toLocaleLowerCase().includes(this.searchTerm.toLowerCase()) : false;
      const isInstructive = item.instructive ? item.instructive.toString().toLocaleLowerCase().includes(this.searchTerm.toLowerCase()): false;
      const isShip = item.ship ?  item.ship.toString().toLocaleLowerCase().includes(this.searchTerm.toLowerCase()): false;
      const isSpeciesName = item.genericDetails?.some(detail => this.getSpeciesName(detail)?.toString().toLocaleLowerCase().includes(this.searchTerm.toLowerCase())) || false;
      const isVariety = item.genericDetails?.some(detail => detail.varietyName?.toString().toLocaleLowerCase().includes(this.searchTerm.toLowerCase())) || false;
      const isCreatedDate = item.importOrder.created ? moment(item.importOrder.created).format("DD-MM-YYYY").toString().toLocaleLowerCase().includes(this.searchTerm.toLowerCase()): false;

      return isOrder || isImporter || isExporter || isContainer || isInstructive || isShip || isSpeciesName || isVariety || isCreatedDate
    } */

    return true;
  }

  getImageUrl(order: ImportOrderInformation): string {
    return OrderUtils.getImageUrl(order)
  }

  getOrderTotalPrice(details: GenericOrderDetail[]): number {
    return OrderUtils.getOrdetTotalPriceGeneric(details)
  }

  getOrderPalletPrice(details: GenericOrderDetail[]): number {
    let total = 0;
    details.forEach(element => {
      total += this.getDetailPalletPrice(element)
    });

    return total;
  }

  getDetailPalletPrice(detail: GenericOrderDetail): number {
    let total = 0

    if(detail.palletPrices)
    {
      detail.palletPrices.forEach(x => {
        total += x.price ? x.boxPerPallets * x.price : 0;
      })
      return total
    }
    return 0
  }

  getOrderTitle(order: ImportOrderInformation): string {
    return OrderUtils.getOrderTitle(order.importOrder.id)
  }

  goToOrderDetailPage(orderId: any) {
    const url = this._router.serializeUrl(
    this._router.createUrlTree([`${Routes.adminOrderManagement}/${orderId}`]))
    window.open(url, '_blank');
  }

  goToDelivery(orderId: any) {
    const url = this._router.serializeUrl(
    this._router.createUrlTree([`${Routes.adminOrderManagement}/${orderId}`]))
    window.open(url, '_blank');
    //this._router.navigate(['/' + Routes.adminOrderManagement, orderId])
  }

  goToOperation(orderId: any) {
    const url = this._router.serializeUrl(
    this._router.createUrlTree([`${Routes.adminOrderManagement}/${orderId}`]))
    window.open(url, '_blank');
    //this._router.navigate(['/' + Routes.adminOrderManagement, orderId])
  }

  buildFilters(filter: AdminOrderFilter)
  {
    this.ordersFilter = [];
    this.programsFilter = [];
    this.importersFilter = [];
    this.exportersFilter = [];
    this.containersFilter = [];
    this.instructivesFilter = [];
    this.shipsFilter = [];
    this.speciesFilter = [];
    this.varietiesFilter = [];

    if(filter.importers.length > 0)
    {
      filter.importers.map(item => {
        this.importersFilter.push(
          {
          label: item.toString(),
          value: item
        })
      })
    }
    if(filter.exporters.length > 0)
    {
      filter.exporters.map(item => {
        this.exportersFilter.push(
          {
          label: item.toString(),
          value: item
        })
      })
    }
    if(filter.containers.length > 0)
    {
      filter.containers.map(item => {
        this.containersFilter.push(
          {
          label: item.toString(),
          value: item
        })
      })
    }
    if(filter.species.length > 0)
    {
      filter.species.map(item => {
        this.speciesFilter.push(
          {
          label: item.toString(),
          value: item
        })
      })
    }
    if(filter.varieties.length > 0)
    {
      filter.varieties.map(item => {
        this.varietiesFilter.push(
          {
          label: item.toString(),
          value: item
        })
      })
    }
    if(filter.programs.length > 0)
    {
      filter.programs.map(item => {
        this.programsFilter.push(
          {
          label: item.toString(),
          value: item
        })
      })
    }
    if(filter.instructions.length > 0)
    {
      filter.instructions.map(item => {
        this.instructivesFilter.push(
          {
          label: item.toString(),
          value: item
        })
      })
    }

    if(filter.sequences.length > 0)
    {
      filter.sequences.map(item => {
        this.ordersFilter.push({
          label: item.toString(),
          value: item
        })
      })
    }
  }

  getAdminOrderFilters()
  {
    this.loading = false;

    this._importOrderService.getAllByStatusFilter(this.request).subscribe({
      next: (v) => {
        this.buildFilters(v);
      },
      error: (e) => {
        this.loading = false
        console.log(e)
        this._messageService.add({
          severity: 'error',
          summary: 'Acción fallida',
          detail: 'Error al consultar los filtros.' });
      }
    })
  }

  getAllByStatusPaged(pageSize = 10,
    pageNumber = 1)
  {
    this.loading = true;
    this.request.pageSize = pageSize;
    this.request.pageNumber = pageNumber;
    this._importOrderService.getAllByStatusPaged(this.request).subscribe({
      next: (v) => {
        this.totalCount = v.totalCount;
        const result: ImportOrderInformation[] = []
        v.items.forEach(x => {
          const fullOrder = this.getFullOrder(x)
          result.push(fullOrder)
        })

        this.orders = result
        this.filteredOrders = result
        this.loading = false;
      },
      error: (e) => {
        this._messageService.add({
          severity: 'error',
          summary: 'Acción fallida',
          detail: 'No se pudieron recuperar las órdenes.'
        });
        this.loading = false;
      }
    })
  }

  changePage(event: LazyLoadEvent)
  {
    this.buildRequestFilter(event.filters)
    if(event.first && event.rows )
    {
      const pageNumber = Math.floor(event.first / event.rows) + 1;
      const pageSize = event.rows;
      this.getAllByStatusPaged(pageSize, pageNumber);
    }else{
       this.getAllByStatusPaged();
    }


  }


  buildRequestFilter(
    tableFilters?: { [key: string]: FilterMetadata | FilterMetadata[] })
  {
    this.request = {
      containers: [],
      exporters: [],
      importers: [],
      isProgram: this.isProgram,
      ships: [],
      varieties: [],
      weeks: [],
      species: [],
      programs: [],
      sequences: [],
      dates: [],
      searchTerm: "",
      instructions: [],
      status: "ImporterOrderConfirmed,ImporterPaymentConfirmed"
    }

     if (typeof this.filterForm.get('orderId')?.value === 'number')
     {
      this.request.sequences.push(this.filterForm.get('orderId')?.value);
     }

     if (typeof this.filterForm.get('programId')?.value === 'number') {
      this.request.programs.push(this.filterForm.get('programId')?.value);
     }

     if (this.filterForm.get('specie')?.value) {
      this.request.species.push(this.filterForm.get('specie')?.value);
     }

    if (this.filterForm.get('variety')?.value) {
      this.request.varieties.push(this.filterForm.get('variety')?.value);
    }

    if(this.filterForm.get('status')?.value)
    {
      this.request.status = this.filterForm.get('status')?.value;
    }

    if(this.searchTerm != "")
    {
      this.request.searchTerm = this.searchTerm;
    }


    if(tableFilters)
    {
      console.log(tableFilters);
      const containerFilter = tableFilters['containerNumber'];
      const exporterFilter = tableFilters['exporterName'];
      const importersFilter = tableFilters['importOrder.importer.companyName'];
      const shipFilter = tableFilters['ship'];
      const instructiveFilter = tableFilters['instructive'];
      const createdFilter = tableFilters['importOrder.created'];
      if(Array.isArray(containerFilter))
      {
        containerFilter.forEach(element => {
          if(element.value != null)
            this.request.containers.push(element.value)
        });
      }

      if(Array.isArray(exporterFilter))
      {
        exporterFilter.forEach(element => {
          if(element.value != null)
          {
            this.request.exporters.push(element.value)
          }

        });
      }

      if(Array.isArray(importersFilter))
      {
        importersFilter.forEach(element => {
          if(element.value != null)
            this.request.importers.push(element.value)
        });
      }

      if(Array.isArray(shipFilter))
      {
        shipFilter.forEach(element => {
          if(element.value != null)
          {
            this.request.ships.push(element.value)
          }
        });
      }


      if(Array.isArray(instructiveFilter))
      {
        instructiveFilter.forEach(element => {
          if(element.value != null){
            this.request.instructions.push(element.value)
          }
        });
      }

      if(Array.isArray(createdFilter))
      {
        createdFilter.forEach(element => {
          if(element.value != null){
          this.request.dates.push(element.value.toDateString())
          }
        })
      }
    }
  }

  changeFilter()
  {
    this.buildRequestFilter()
    this.getAllByStatusPaged()
    this.getAdminOrderFilters()
  }

}
